import React, { Component } from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import TextInput from '../../common/components/textinput/TextInput';
import Voucherify from 'voucherify.js';
import colors from '../../common/components/ui/colors';
import Icon from "../../common/components/icon/Icon";
import { ICONS } from "../../common/components/icon/Icons";
import { Label, Checkbox } from "../../common/components/checkbox/CheckBox";
import withLocalized from '../../localization/withLocalized';

const KEY_ENTER_CODE = 13;

const VoucherContainer = styled.section`
  position: relative;
  
  svg {
    padding-right: 0.875rem;
  }
  
  &.validation-failed {
    div {
      border-color: ${colors.FIELD_ERROR};
    }
  }
  
  .voucher-field__checkbox-label {
    margin-bottom: 1rem;
  } 
`;

const ApplyVoucherButton = styled.a`
  font-weight: bold;
  color: ${colors.BRAND_GREEN}; 
  padding: 0.875rem;
  cursor: pointer;
`;

const VoucherError = styled.p`
  font-size: ${14/16}rem;
  margin-bottom: 1rem;
  text-align: center;
  color: ${colors.FIELD_ERROR};
`;

class VoucherFieldLocalized extends Component {

  static propTypes = {
    onCodeValid: PropTypes.func.isRequired,
    onCodeInvalid: PropTypes.func.isRequired,
    getVoucherPrice: PropTypes.func,
    getVoucherMetaData: PropTypes.func,
    getVoucherCustomerObject: PropTypes.func,
  };

  static defaultProps = {};

  state = {};
  typedCode = '';

  constructor() {
    super();
    Voucherify.initialize(
      process.env.REACT_APP_VOUCHERIFY_APPLICATION_ID || '660ff3a0-5abe-42b5-baf3-7c56fa348e08',
      process.env.REACT_APP_VOUCHERIFY_CLIENT_SECRET_KEY || '8897e6df-fe93-4969-b80a-1559c8981170',
    );
  }

  _formValidationPayload = (code) => {
    return {
      code,
      amount: this.props.getVoucherPrice ? this.props.getVoucherPrice() : 0,
      metadata: this.props.getVoucherMetaData ? this.props.getVoucherMetaData() : {},
      customer: this.props.getVoucherCustomerObject ? this.props.getVoucherCustomerObject() : {},
    };
  };

  /*
    Sandbox test codes:
      voucherify.io-10-amount-off
      voucherify.io-10-percent-off
      voucherify.io-expired
      voucherify.io-exceeded

     Prod:
      BT-GIFTMTeVw6RG
   */
  _validateCode(code) {

    if (this.validationInProgress) return;

    this.validationInProgress = true;

    if (code === this.state.code) {
      this.validationInProgress = false;
      return;
    }

    if (!code) {
      if (this.state.valid || this.state.validationFailed) {
        this._resetState();
      }

      this.validationInProgress = false;
      return;
    }

    this.setState({ code, isLoading: true }, () => {

      const params = this._formValidationPayload(code);

      Voucherify.validate(params, (response) => {


        this.setState({ isLoading: false }, () => {

          if (response.valid) {
            this._acceptCode(response);
          } else {
            this._rejectCode(response);
          }

          this.validationInProgress = false;
        });
      });
    });
  }

  _acceptCode(apiResponse) {
    this.setState({ valid: true, validationFailed: false  }, () => {
      this.props.onCodeValid(apiResponse);
    })
  }

  _rejectCode(apiResponse) {
    this.setState({ valid: false, validationFailed: true }, () => {
      this.props.onCodeInvalid(apiResponse);
    })
  }

  _fieldBlurred = (e) => {
    this._validateCode(e.target.value);
  };

  _fieldKeyDown = (e) => {
    if (e.keyCode === KEY_ENTER_CODE) {
      e.stopPropagation();
      this._validateCode(e.target.value);
    }
  };

  _fieldChanged = (e) => {
    this.typedCode = e.target.value;
  };

  _validateCodeWithButton = () => {
    this._validateCode(this.typedCode);
  };

  _resetState() {
    this.props.onCodeInvalid({});
    this.typedCode = '';
    this.setState({
      code: '',
      valid: false,
      validationFailed: false
    });
  }

  _toggleVoucherInputField = (e) => {
    this.setState({
      displayTextInput: !this.state.displayTextInput
    }, () => {
      if (!this.state.displayTextInput) {
        this._resetState();
      }
    });
  };

  _renderVoucherTextInput() {
    const { localized } = this.props;
    if (this.state.displayTextInput) {
      return (
        <TextInput
          name={'voucher_code'}
          placeholder={localized('booking.form.voucher_placeholder')}
          onBlur={this._fieldBlurred}
          onKeyDown={this._fieldKeyDown}
          onChange={this._fieldChanged}
          theme={this.props.theme}
        >
          { !this.state.valid &&
          <ApplyVoucherButton onClick={this._validateCodeWithButton}>
            { localized('booking.form.voucher_apply') }
          </ApplyVoucherButton>
          }
          { this.state.valid &&
          <Icon
            icon={ICONS.CHECKMARK}
            width="26px"
            height="20px"
            fill={colors.BRAND_GREEN}
          />
          }
        </TextInput>
      );
    }

    return null;
  }

  _renderErrorField() {
    const { localized } = this.props;
    if (this.state.validationFailed) {
      return (
        <VoucherError>
          { localized('booking.form.voucher_error') }
        </VoucherError>
      );
    }

    return null;
  }

  _renderToggleButton() {
    const { localized } = this.props;
    return (
      <Label htmlFor="voucher-typed" className="voucher-field__checkbox-label">
        <Checkbox type="checkbox" name="voucher-typed" id="voucher-typed" onChange={this._toggleVoucherInputField} /> { localized('booking.form.voucher_use') }
      </Label>
    )
  }

  render () {

    const containerClassNames = this.state.validationFailed ? 'validation-failed' : null;

    return (
      <VoucherContainer className={containerClassNames}>
        { this._renderToggleButton() }
        { this._renderVoucherTextInput() }
        { this._renderErrorField() }
      </VoucherContainer>
    );
  }
}

const VoucherField = withLocalized(VoucherFieldLocalized);

export {
  VoucherField
};



// WEBPACK FOOTER //
// ./src/modules/booking/components/VoucherField.js